namespace app.tarefas.minhasTarefas {
    "use strict";
    
    import ITranslatePartialLoaderProvider = ng.translate.ITranslatePartialLoaderProvider;
    import IStateProvider = ng.ui.IStateProvider;
    import AuthService = app.autenticacao.AuthService;
    import INotification = app.notification.INotification;
    import IRootScopeService = ng.IRootScopeService;
    import ITimeoutService = ng.ITimeoutService;
    import AuthorizationService = app.support.authorization.AuthorizationService;

    declare let angular: ng.IAngularStatic;

    /** @ngInject **/
    function config($translatePartialLoaderProvider: ITranslatePartialLoaderProvider,
                    $stateProvider: IStateProvider,
                    msNavigationServiceProvider: {}) {

        $translatePartialLoaderProvider.addPart("app/main/tarefas/minhas-tarefas");

        $stateProvider.state("app.tarefas.minhas-tarefas", {
            url : "",
            views : {
                "content@app.autenticado" : {
                    templateUrl : "app/main/tarefas/minhas-tarefas/minhas-tarefas.html",
                    controller : MinhasTarefasController,
                    controllerAs : "vm"
                }
            },
            resolve : {
                iframe: ['$q', function($q){
                    if (window !== parent) {
                        parent.postMessage({"type": "iframe", "operation": "abrir-tarefas"}, "*");
                       return $q.reject('Abrir tarefas');
                    }
                }],
                user : /** @ngInject */ (authService: AuthService) => {
                    return authService.isAuthenticated();
                },
                userGroups : /** @ngInject */ (minhasTarefasService: MinhasTarefasService) => {
                    return minhasTarefasService.listGroups();
                },
                canPrioritize: /** @ngInject */ (authorizationService: AuthorizationService) => {
                    return authorizationService.findPermission("priorizar-tarefa", null)
                                         .then(() => true)
                                         .catch(() => false);
                },
                canAnnotate : /** @ngInject */ (authorizationService: AuthorizationService) => {
                    return authorizationService.findPermission("anotar-tarefa", null)
                                         .then(() => true)
                                         .catch(() => false);
                },
                canTag : /** @ngInject */ (authorizationService: AuthorizationService) => {
                    return authorizationService.findPermission("adicionar-rotulo-tarefa", "integracoes-tarefas")
                                         .then(() => true)
                                         .catch(() => false);
                },
                canRemoveTags : /** @ngInject */ (authorizationService: AuthorizationService) => {
                    return authorizationService.findPermission("remover-rotulo-tarefa", "integracoes-tarefas")
                                         .then(() => true)
                                         .catch(() => false);
                },
                manualTags : /** @ngInject */ (rotulosService: RotulosService) => {
                    return rotulosService.loadManualTags();
                }
            }
        }).state("app.tarefas.minhas-tarefas.historico", {
            url : "/historico",
            views : {
                "content@app.autenticado" : {
                    templateUrl : "app/main/tarefas/minhas-tarefas/historico.html",
                    controller : HistoricoTarefasController,
                    controllerAs : "vm"
                }
            },
            resolve : {
                user : /** @ngInject */ (authService: AuthService) => {
                    return authService.isAuthenticated();
                },
                userGroups : /** @ngInject */ (minhasTarefasService: MinhasTarefasService) => {
                        return minhasTarefasService.listGroups();
                }
            }
        });

        msNavigationServiceProvider["saveItem"]("tarefas.minhas-tarefas", {
            title : "Todas Tarefas",
            icon : "icon-view-list",
            state : "app.tarefas.minhas-tarefas",
            translation : "TAREFAS.MEUS-PAINEIS.MEUS-PAINEIS",
            weight : 1
            /*badge : {
                content : 1,
                color : '#03A9F3'
            }*/
        });
    }
    
    /** @ngInject **/
    function run($rootScope: IRootScopeService, $timeout: ITimeoutService, minhasTarefasService: MinhasTarefasService) {
        
        $rootScope.$on("task:created", (event: ng.IAngularEvent, notification: INotification) => {
            $timeout(() => minhasTarefasService.notifyOpenTask(notification), 1000);
        });
        
        $rootScope.$on("task:completed", (event: ng.IAngularEvent, notification: INotification) => {
            minhasTarefasService.deleteTaskDraftByNotification(notification);
        });
    }

     /** @ngInject **/
    function autoOpen($timeout: ITimeoutService) {
        return {
            restrict: 'A',
            require: 'mdDatepicker',
            link: function(scope, element, attrs, DatePickerCtrl) {
                scope.$watch(attrs.autoOpen, function(value) {
                    if(value) {
                        $timeout(function() {
                            DatePickerCtrl.openCalendarPane({
                                target: element[0].children[0]
                            });
                        });
                    }
                });
            }
        };
    }

    angular
        .module("app.tarefas.minhas-tarefas", ["app.tarefas"])
        .directive('autoOpen', autoOpen)
        .config(config)
        .run(run);
}
